import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";
import EmbedController from "../../../../embed/EmbedController";

export const HeadersBuildSection = ({ brandLogo, headerLabel, headerLineImgSrc, subheaderLabel, finalPrice, setShowBikeModal }) => {
  // custom code thrill code
  const displayBrandLogo = isMobile && EmbedController.isEmbedded ? false : true;
  return (
    <div className="headers d-flex flex-column pt-2">
      {finalPrice && <h5 className="priceInHeader mt-1">{finalPrice} </h5>}
      {headerLabel && <h5 className="text-center pt-1 mb-0">{headerLabel}</h5>}
      {displayBrandLogo && (
        <>
          <img style={{ width: "130px" }} className="mx-auto mb-0" alt="brand logo" src={brandLogo} />
          <img style={{ width: "100px" }} className="mt-1 mx-auto" alt="header underline" src={headerLineImgSrc} />
        </>
      )}
      {subheaderLabel && (
        <div className="position-relative mt-1 mb-0">
          <h5 className="mb-0 text-center" style={{ cursor: "pointer", margin: "0 auto", position: "relative" }} onClick={() => setShowBikeModal(true)}>
            {subheaderLabel}
            <img
              src="/images/edit-red.png"
              alt="edit bike"
              style={{
                width: "16px",
                height: "16px",
                cursor: "pointer",
                marginLeft: "5px",
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowBikeModal(true);
              }}
            />
          </h5>
        </div>
      )}
    </div>
  );
};

HeadersBuildSection.propTypes = {
  brandLogo: PropTypes.string,
  headerLabel: PropTypes.string,
  headerLineImgSrc: PropTypes.string,
  subheaderLabel: PropTypes.string,
  finalPrice: PropTypes.string,
  setShowBikeModal: PropTypes.func,
};
